// Mount point for the discounts section (#36401, starting with #36369).
const Discounts = () => null;

export default Discounts;
